import React from 'react';
import { SelectNoneAsync } from '../../components/input/select/main';
import { IActivityType } from '../../models/components/filters';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import Translator from '../../core/i18n';
const T = Translator.create();
interface ISelectActivityType {
    value: any;
    label: string;
}

export class ActivityType extends React.Component<IActivityType> {
    public handleSelectedActivityTypes = (e: ISelectActivityType[]): ActivityTypeEnums[] => {
        const activityTypes: ActivityTypeEnums[] = [];
        if (e && e.length) {
            e.forEach(course => activityTypes.push(course.value));
        }
        return activityTypes;
    }

    public render() {
        const activityTypes = [
            { value: ActivityTypeEnums.Assignment, label: T.t('r_activity_type_Assignment') },
            { value: ActivityTypeEnums.Document, label: T.t('r_activity_type_Document') },
            { value: ActivityTypeEnums.Forum, label: T.t('r_activity_type_Forum') },
            { value: ActivityTypeEnums.Video, label: T.t('r_activity_type_Video') },
            { value: ActivityTypeEnums.Elesson, label: T.t('r_activity_type_Elesson') },
            { value: ActivityTypeEnums.Exam, label: T.t('r_activity_type_Exam') },
            { value: ActivityTypeEnums.VirtualClass, label: T.t('r_activity_type_VirtualClass') },
            { value: ActivityTypeEnums.Survey, label: T.t('r_activity_type_Survey') },
            { value: ActivityTypeEnums.MorpaActivity, label: T.t('r_activity_type_MorpaActivity') },
            { value: ActivityTypeEnums.LinkActivity, label: T.t('r_activity_type_LinkActivity') },
            { value: ActivityTypeEnums.TelegramActivity, label: T.t('r_activity_type_TelegramActivity') },
            { value: ActivityTypeEnums.Project, label: T.t('r_activity_type_Project') }
        ];

        return (
            <SelectNoneAsync
                isMulti={true}
                name={this.props.name}
                touched={this.props.touched}
                errors={this.props.errors}
                setFieldValue={this.props.formik.setFieldValue}
                setOptions={activityTypes}
                // tslint:disable-next-line:jsx-no-lambda
                onChange={(e: any) => this.props.formik.setFieldValue(this.props.name, this.handleSelectedActivityTypes(e))}
                isTouched={this.props.formik.setFieldTouched}
                placeHolder={T.t('r_gen_filter_activityType')}
                className='k365-select'

            />
        );
    }
}